export default __webpack_public_path__ + "static/Gilroy-Medium-9f1092d036076c58004147643fcedf04.otf";